import { z } from 'zod/v4'
import { ToolCallCommandSchema } from './schemas'

export const AppServiceSchema = ToolCallCommandSchema
export type AppService = z.infer<typeof AppServiceSchema>
